module.exports = __webpack_public_path__ + "img/logo-dark.cf62271f.png";